import { TSortOffersHistoryBy } from 'shared/components/OfferHistory/types/types';
import { EOrderBy } from 'shared/repositories/valuation-offer-history/entities/offer_history/HouseOfferHistoryRequestV4Schema';

export const SORT_OFFERS_HISTORY_BY: TSortOffersHistoryBy[] = [
  { value: EOrderBy.AreaAsc, label: 'По площади, по возрастанию' },
  { value: EOrderBy.AreaDesc, label: 'По площади, по убыванию' },
  { value: EOrderBy.PriceAsc, label: 'По цене, по возрастанию' },
  { value: EOrderBy.PriceDesc, label: 'По цене, по убыванию' },
  { value: EOrderBy.PubDateAsc, label: 'По дате публикации, по возрастанию' },
  { value: EOrderBy.PubDateDesc, label: 'По дате публикации, по убыванию' },
];
